// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rryl","toggle":"styles_toggle__7HJQF","preview":"styles_preview__3WaAF"};